import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./labs/App";
import { AuthProvider, AuthProviderProps } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
/* Comment below to make it work with local api */
import { Amplify } from "aws-amplify";
import awsExports from "./aws-exports";
import { HelmetProvider } from "react-helmet-async";
import { cognitoTokenProvider } from "./cognitoTokenProvider";

const restConfig = awsExports.aws_cloud_logic_custom[0]; // { name, endpoint, region }

Amplify.configure({
  API: {
    REST: {
      [restConfig.name]: {
        endpoint: restConfig.endpoint,
        region: restConfig.region,
      },
    },
    Events: {
      endpoint: 'https://ok4ufl7hnjggtnepbhj35xsque.appsync-api.us-west-2.amazonaws.com/event',
      region: 'us-west-2',
      defaultAuthMode: 'userPool',
    },
  },
},
{
  Auth: {
    tokenProvider: cognitoTokenProvider,
  },
});

const isLocal = window.location.hostname === "localhost";

const cognitoAuthConfig: AuthProviderProps = {
  authority: "https://cognito-idp.us-west-2.amazonaws.com/us-west-2_h7nTBqeQS",
  client_id: "1ltrrg50umnijv7h38aku4ufpr",
  redirect_uri: isLocal
    ? "http://localhost:3000"
    : "https://hbgamelabs.com",
  post_logout_redirect_uri: isLocal
    ? "http://localhost:3000"
    : "https://hbgamelabs.com",
  response_type: "code",
  scope: "phone openid email profile",
  userStore: new WebStorageStateStore({ store: window.localStorage }),
  automaticSilentRenew: true,       // automatically refresh before expiry
  silent_redirect_uri: `${window.location.origin}/silent-renew.html`
};

const container = document.getElementById("root");
const root = createRoot(container!);

root.render(
  <AuthProvider {...cognitoAuthConfig}>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </AuthProvider>
);